import { CircularProgress, Paper, PaperProps, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useScheduledActionInvoiceClaimQuery } from '../../../../api/gql';
import { AdminClaimDataOverview } from '../../../../modules/claims/claim/ClaimDataOverview';
import { TaskIdInvoiceInfoBox } from './TaskIdInvoiceInfoBox';

type Props = {
  taskId: string;
} & PaperProps;

export const TaskIdInvoiceOrClaimInfoBox = ({ taskId, ...rest }: Props) => {
  const { t } = useTranslation('page-admin-task-detail');
  const { data, isLoading } = useScheduledActionInvoiceClaimQuery({
    id: taskId,
  });

  if (isLoading) {
    return <CircularProgress />;
  }

  if (data?.scheduledAction.invoiceClaim) {
    return (
      <Paper sx={{ p: 4 }} {...rest}>
        <Typography variant={'h2'} mb={4}>
          {t('claim')}
        </Typography>
        <AdminClaimDataOverview id={data?.scheduledAction.invoiceId} />
      </Paper>
    );
  }

  return <TaskIdInvoiceInfoBox taskId={taskId} {...rest} />;
};
